<template>
  <div class="row">
    <!-- Collections By Sub Counties -->
    <div class="col-3">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title text-left">Collections By Sub Counties</h4>
          <div class="table-responsive font-12" style="height: 385px; overflow-y: auto;">
            <table class="table table-striped table-sm font-12 sources-table">
              <thead>
              <tr class="font-weight-bold table-dark">
                <th scope="col">Sub Counties</th>
                <th scope="col">Today</th>
                <th scope="col">FY</th>
              </tr>
              </thead>
              <tbody>
              <tr @click="gotToPage('reports-sub-counties-details', item)"
                  style="cursor: pointer;"
                  v-for="(item, index) in subCountiesRevenue"
                  :value="item" :key="index">
                <td scope="row">{{item.subCountyName}}</td>
                <td>{{numberFormat(item.todayAmount)}}</td>
                <td>{{numberFormat(item.totalAmount)}}</td>
              </tr>
              <tr style="background: #cee9d8;">
                <th><strong>Total</strong></th>
                <th>KES {{numberFormat(totalTodaySubCounty)}}</th>
                <th>KES {{numberFormat(totalFYSubCounty)}}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="getRight('DOWNLOAD REPORTS')" class="card-footer bg-transparent border-top">
          <div class="text-center">
            <a type="button"
               class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize"
               data-toggle="modal" data-target="#selectDate">
              <i class="mdi mdi-download font-size-10"></i>
              <span class="pl-1 d-md-inline">Download</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Revenue Collection By Wards -->
    <div class="col-3">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title text-left">Revenue Collection By Wards</h4>
          <div class="table-responsive font-12" style="height: 385px; overflow-y: auto;">
            <table class="table table-striped table-sm font-12 sources-table">
              <thead class="table-dark">
              <tr class="font-weight-bold">
                <th scope="col">Wards</th>
                <th scope="col">Today</th>
                <th scope="col">FY</th>
              </tr>
              </thead>
              <tbody>
              <tr @click="vieMore(item.wardName)"
                  style="cursor: pointer;"
                  v-for="(item, index) in wardsRevenue"
                  :value="item" :key="index">
                <td scope="row">{{item.wardName}}</td>
                <td>{{numberFormat(item.todayAmount)}}</td>
                <td>{{numberFormat(item.totalAmount)}}</td>
              </tr>
              <tr style="background: #cee9d8;">
                <th><strong>Total</strong></th>
                <th>KES {{numberFormat(totalTodayWards)}}</th>
                <th>KES {{numberFormat(totalFYSubCounty)}}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="getRight('DOWNLOAD REPORTS')" class="card-footer bg-transparent border-top">
          <div class="text-center">
            <a @click="gotTo('bills-receipted')" class="btn btn-primary waves-effect waves-light">
              View All
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Revenue Collection By Zones -->
    <div class="col-3">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Revenue Collection By Zones</h4>
          <div class="table-responsive font-12" style="height: 385px; overflow-y: auto;">
            <table class="table table-striped table-sm font-12 sources-table">
              <thead class="table-dark">
              <tr class="font-weight-bold tex">
                <th scope="col">Zones</th>
                <th scope="col">Today</th>
                <th scope="col">FY</th>
              </tr>
              </thead>
              <tbody>
              <tr @click="gotToDetail('reports-sub-county-zones-details', item.zone)"
                  style="cursor: pointer;"
                  v-for="(item, index) in zonesRevenue"
                  :value="item" :key="index">
                <td scope="row">{{item.zone}}</td>
                <td>{{numberFormat(item.todayAmount)}}</td>
                <td>{{numberFormat(item.totalAmount)}}</td>
              </tr>
              <tr style="background: #cee9d8;">
                <th><strong>Total</strong></th>
                <th>KES {{numberFormat(totalTodayZones)}}</th>
                <th>KES {{numberFormat(totalFYSubCounty)}}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="getRight('DOWNLOAD REPORTS')" class="card-footer bg-transparent border-top">
          <div class="text-center">
            <a @click="gotTo('bills-receipted')" class="btn btn-primary waves-effect waves-light">
              View All
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Collections By Departments -->
    <div class="col-3">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title text-left">Collections By Departments</h4>
          <div class="table-responsive font-12" style="height: 385px; overflow-y: auto;">
            <table class="table table-striped table-sm font-12 sources-table">
              <thead>
              <tr class="font-weight-bold table-dark">
                <th scope="col">Departments</th>
                <th scope="col">Today</th>
                <th scope="col">FY</th>
              </tr>
              </thead>
              <tbody>
              <tr @click="vieMore(item.department)"
                  style="cursor: pointer;"
                  v-for="(item, index) in departmentRevenue"
                  :value="item" :key="index">
                <td scope="row">{{item.department}}</td>
                <td>{{numberFormat(item.todayAmount)}}</td>
                <td>{{numberFormat(item.totalAmount)}}</td>
              </tr>
              <tr style="background: #cee9d8;">
                <th><strong>Total</strong></th>
                <th>KES {{numberFormat(totalTodayDepartments)}}</th>
                <th>KES {{numberFormat(totalFYSubCounty)}}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="getRight('DOWNLOAD REPORTS')" class="card-footer bg-transparent border-top">
          <div v-if="getRight('DOWNLOAD REPORTS')" class="text-center">
            <a @click="gotTo('bills-receipted')" class="btn btn-primary waves-effect waves-light">View All</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { biller, execute, getRight } from "@/api";
import router from "@/router";

export default {
  name: "RevenueCollectionTables",
  data() {
    return {
      departmentRevenue: [],
      zonesRevenue: [],
      wardsRevenue: [],
      subCountiesRevenue: [],
      totalTodaySubCounty: 0,
      totalFYSubCounty: 0,
      totalTodayWards: 0,
      totalFYWards: 0,
      totalTodayZones: 0,
      totalFYZones: 0,
      totalTodayDepartments: 0,
      totalFYDepartments: 0,
      selectedMonth: '',
      selectedYear: ''
    }
  },
  mounted() {
    let currentMonth = new Date();
    this.selectedMonth = currentMonth.toLocaleDateString("en-US", { month: "short", year: "numeric" });

    this.getDepartmentRevenue();
    this.getSubCountiesRevenue();
    this.getWardsRevenue();
    this.getZonesRevenue();
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },
    getRight(type) {
      return getRight(type);
    },
    gotTo(route) {
      router.push(route);
    },
    gotToPage(route, item) {
      sessionStorage.setItem("currentPage", route);
      sessionStorage.setItem("subCountyName", item.subCountyName);
      sessionStorage.setItem("subCountyID", item.subCountyID);
      router.push(route);
    },
    gotToDetail(route, zone) {
      sessionStorage.setItem("zone", zone);
      router.push(route);
    },
    vieMore(keyword) {
      sessionStorage.setItem("keyword", keyword);
      this.gotTo('department-performance');
    },
    calculateTotals() {
      // Calculate SubCounty totals
      this.totalTodaySubCounty = (this.subCountiesRevenue || []).reduce((acc, cur) => {
        let todayAmount = Number(cur.todayAmount);
        return acc + (isNaN(todayAmount) ? 0 : todayAmount);
      }, 0);

      this.totalFYSubCounty = (this.subCountiesRevenue || []).reduce((acc, cur) => {
        let totalAmount = Number(cur.totalAmount);
        return acc + (isNaN(totalAmount) ? 0 : totalAmount);
      }, 0);

      // Calculate Wards totals
      this.totalTodayWards = (this.wardsRevenue || []).reduce((acc, cur) => {
        let todayAmount = Number(cur.todayAmount);
        return acc + (isNaN(todayAmount) ? 0 : todayAmount);
      }, 0);

      this.totalFYWards = (this.wardsRevenue || []).reduce((acc, cur) => {
        let totalAmount = Number(cur.totalAmount);
        return acc + (isNaN(totalAmount) ? 0 : totalAmount);
      }, 0);

      // Calculate Zones totals
      this.totalTodayZones = (this.zonesRevenue || []).reduce((acc, cur) => {
        let todayAmount = Number(cur.todayAmount);
        return acc + (isNaN(todayAmount) ? 0 : todayAmount);
      }, 0);

      this.totalFYZones = (this.zonesRevenue || []).reduce((acc, cur) => {
        let totalAmount = Number(cur.totalAmount);
        return acc + (isNaN(totalAmount) ? 0 : totalAmount);
      }, 0);

      // Calculate Departments totals
      this.totalTodayDepartments = (this.departmentRevenue || []).reduce((acc, cur) => {
        let todayAmount = Number(cur.todayAmount);
        return acc + (isNaN(todayAmount) ? 0 : todayAmount);
      }, 0);

      this.totalFYDepartments = (this.departmentRevenue || []).reduce((acc, cur) => {
        let totalAmount = Number(cur.totalAmount);
        return acc + (isNaN(totalAmount) ? 0 : totalAmount);
      }, 0);
    },
    getDepartmentRevenue() {
      const cachedData = localStorage.getItem("departmentRevenue");
      if (cachedData) {
        this.departmentRevenue = JSON.parse(cachedData);
        this.calculateTotals();
      }

      const data = new FormData();
      data.append("function", "departmentRevenue");
      data.append("month", this.selectedMonth);
      data.append("year", this.selectedYear);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.departmentRevenue = res.data.data.departmentRevenue;
              localStorage.setItem("departmentRevenue", JSON.stringify(this.departmentRevenue));
              this.calculateTotals();
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
    },
    getSubCountiesRevenue() {
      const cachedData = localStorage.getItem("subCountiesRevenue");
      if (cachedData) {
        this.subCountiesRevenue = JSON.parse(cachedData);
        this.calculateTotals();
      }

      const data = new FormData();
      data.append("function", "getSubCountiesRevenue");
      data.append("month", this.selectedMonth);
      data.append("year", this.selectedYear);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCountiesRevenue = res.data.data.subCountiesRevenue;
              localStorage.setItem("subCountiesRevenue", JSON.stringify(this.subCountiesRevenue));
              this.calculateTotals();
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
    },
    getWardsRevenue() {
      const cachedData = localStorage.getItem("wardsRevenue");
      if (cachedData) {
        this.wardsRevenue = JSON.parse(cachedData);
        this.calculateTotals();
      }

      const data = new FormData();
      data.append("function", "wardsRevenue");
      data.append("month", this.selectedMonth);
      data.append("year", this.selectedYear);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wardsRevenue = res.data.data.wardsRevenue;
              localStorage.setItem("wardsRevenue", JSON.stringify(this.wardsRevenue));
              this.calculateTotals();
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
    },
    getZonesRevenue() {
      const cachedData = localStorage.getItem("zonesRevenue");
      if (cachedData) {
        this.zonesRevenue = JSON.parse(cachedData);
        this.calculateTotals();
      }

      const data = new FormData();
      data.append("function", "zonesRevenue");
      data.append("month", this.selectedMonth);
      data.append("year", this.selectedYear);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.zonesRevenue = res.data.data.zonesRevenue;
              localStorage.setItem("zonesRevenue", JSON.stringify(this.zonesRevenue));
              this.calculateTotals();
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
    }
  }
}
</script>